const FIRST_NAME_REQUIRED = 'First Name is Required';
const LAST_NAME_REQUIRED = 'Last Name is Required';
const USER_NAME_REQUIRED = 'User Name is Required';
const EMAIL_REQUIRED = 'Email is Required';
const EMAIL_ERROR = 'Invalid Email';
const ROLE_REQUIRED = 'Role is Required';

const addAgentDefaultValues = {
  firstName: '',
  lastName: '',
  email: '',
  role: null,
  userName: '',
  isActive: true,
};

export {
  FIRST_NAME_REQUIRED,
  LAST_NAME_REQUIRED,
  USER_NAME_REQUIRED,
  EMAIL_REQUIRED,
  EMAIL_ERROR,
  ROLE_REQUIRED,
  addAgentDefaultValues,
};
